(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  // Check if the URL has the recover parameter
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('recover')) {
    // Toggle visibility of forms
    document.querySelector('.recover-form').style.display = 'block';
    document.querySelector('.login-form-container').style.display = 'none';
  }
  
  // Handle back to login from recovery form
  document.addEventListener('DOMContentLoaded', function() {
    const cancelLink = document.querySelector('.recover-form a[style*="text-align: center"]');
    if (cancelLink) {
      cancelLink.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelector('.recover-form').style.display = 'none';
        document.querySelector('.login-form-container').style.display = 'block';
        // Update URL without the recover parameter
        history.pushState({}, '', window.location.pathname);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"] && !Shopify.designMode) return;
  try {
    
// Intersection Observer for scroll animations
document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, {
    threshold: 0.1
  });
  
  // Observe all elements with animation classes
  const animatedElements = document.querySelectorAll('.fade-in, .slide-in');
  animatedElements.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
